import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, TextField, Button, Paper, Stack, Alert } from '@mui/material';
import { ordersAPI } from '../../Api';
import './style.css';
const initialMessages = [
  // Пример начальных сообщений
  // { from: 'client', text: 'Здравствуйте!' },
  // { from: 'seller', text: 'Добрый день!' },
];


export default function ChatPage() {
  const { id } = useParams();
  const [messages, setMessages] = useState(initialMessages);
  const [clientMsg, setClientMsg] = useState('');
  const [sellerMsg, setSellerMsg] = useState('');
  const [orderClosed, setOrderClosed] = useState(false);
  const [chatHtml, setChatHtml] = useState('');

  const sendClientMsg = async () => {
    if (orderClosed) return;
    if (clientMsg.trim()) {
      setClientMsg('');
     const response = await ordersAPI.getFunPayChatSendClient(id, clientMsg);
     const chatHtml = response.data.data.chatHtml;
     setChatHtml(chatHtml);
    }
  };
  const sendSellerMsg = async () => {
    if (orderClosed) return;
    if (sellerMsg.trim()) {
        setSellerMsg('');
        const response = await ordersAPI.getFunPayChatSendSeller(id, sellerMsg);
        const chatHtml = response.data.data.chatHtml;
        setChatHtml(chatHtml);
    }
  };
  useEffect(() => {
    const fetchChat = async () => {
      try {
        const response = await ordersAPI.getFunPayChat(id);
        const chatHtml = response.data.data.chatHtml;
        console.log(chatHtml);
        setChatHtml(chatHtml);
        // setMessages([...messages, { from: 'client', text: chatHtml }]);
      } catch (error) {
        console.error('Ошибка при получении чата:', error);
      }
    };
    fetchChat();
  }, []);
  const closeOrder = async () => {
    const response = await ordersAPI.getFunPayChatClose(id)
    setChatHtml(response.data.data.chatHtml);
    setOrderClosed(true);
    
    // Здесь можно сделать реальный запрос к API для закрытия ордера
    // ordersAPI.closeOrder(id)
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6">Чат по ордеру: <b>{id}</b></Typography>
      </Paper>
      <Paper
        sx={{
          p: 2,
          minHeight: 250,
          maxHeight: 250,
          mb: 2,
          overflowY: 'scroll',
          overflowAnchor: 'end',

        }}
      >
        <div dangerouslySetInnerHTML={{ __html: chatHtml }} />
      </Paper>
      {orderClosed && <Alert severity="success" sx={{ mb: 2 }}>Ордер закрыт</Alert>}
      <Stack direction="row" spacing={2} mb={1}>
        <TextField
          label="Сообщение от клиента"
          value={clientMsg}
          onChange={e => setClientMsg(e.target.value)}
          fullWidth
          size="small"
          disabled={orderClosed}
        />
        <Button variant="contained" onClick={sendClientMsg} disabled={orderClosed}>Отправить</Button>
      </Stack>
      <Stack direction="row" spacing={2} mb={2}>
        <TextField
          label="Сообщение от продавца"
          value={sellerMsg}
          onChange={e => setSellerMsg(e.target.value)}
          fullWidth
          size="small"
          disabled={orderClosed}
        />
        <Button variant="contained" color="success" onClick={sendSellerMsg} disabled={orderClosed}>Отправить</Button>
      </Stack>
      <Button
        variant="contained"
        color="primary"
        size="large"
        fullWidth
        sx={{ mt: 2, fontWeight: 600, fontSize: 18 }}
        onClick={closeOrder}
        disabled={orderClosed}
      >
        Подтвердить
      </Button>
    </Box>
  );
}
